var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { format } from 'date-fns';
import { ROLE } from 'shared/types';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  padding: 30px 30px 100px;\n\n  > table {\n    width: 100%;\n    border-collapse: collapse;\n    \n    tr {\n      text-align: center;\n      \n      &:nth-child(even) {\n        background: #fafafa;\n      }\n      \n      > td {\n        padding: 20px;\n        font-size: 16px;\n      }\n    }\n\n    > thead {\n      > tr {\n        background: #333;\n        color: #fff;\n      }\n    }\n    \n    > tbody {\n\n    }\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  padding: 30px 30px 100px;\n\n  > table {\n    width: 100%;\n    border-collapse: collapse;\n    \n    tr {\n      text-align: center;\n      \n      &:nth-child(even) {\n        background: #fafafa;\n      }\n      \n      > td {\n        padding: 20px;\n        font-size: 16px;\n      }\n    }\n\n    > thead {\n      > tr {\n        background: #333;\n        color: #fff;\n      }\n    }\n    \n    > tbody {\n\n    }\n  }\n"])));
var GET_MEMBERS = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query GetMembers {\n    allUsers {\n      id\n      email\n      createdAt\n      name\n      role\n    }\n  }\n"], ["\n  query GetMembers {\n    allUsers {\n      id\n      email\n      createdAt\n      name\n      role\n    }\n  }\n"])));
export default (function () {
    function getRole(role) {
        switch (role) {
            case ROLE.ADMINISTRATOR: return '최고관리자';
            case ROLE.MANAGER: return '매니저';
            case ROLE.MEMBER: return '일반회원';
            case ROLE.BANNED: return '강등회원';
            case ROLE.AWAITER: return '가입대기';
        }
    }
    return (React.createElement(Query, { query: GET_MEMBERS }, function (_a) {
        var loading = _a.loading, error = _a.error, data = _a.data;
        if (loading || error)
            return null;
        return (React.createElement(Container, null,
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "\uC774\uBA54\uC77C"),
                        React.createElement("td", null, "\uB2C9\uB124\uC784"),
                        React.createElement("td", null, "\uAC00\uC785\uC77C"),
                        React.createElement("td", null, "\uB4F1\uAE09"))),
                React.createElement("tbody", null, data.allUsers.map(function (user, idx) {
                    return (React.createElement("tr", { key: idx },
                        React.createElement("td", null, user.email),
                        React.createElement("td", null, user.name),
                        React.createElement("td", null, format(Number(user.createdAt), 'YYYY-MM-DD')),
                        React.createElement("td", null, getRole(user.role))));
                })))));
    }));
});
var templateObject_1, templateObject_2;
